import React from "react";
import classnames from "classnames";
import Email from "./Email";
import Social from "./Social";
import Video from "./Video";
import SMS from "./SMS";
import Contactless from "./Contactless";
import Header from "./Header";

const SellAnywhere = (props) => (
  <section className="flex-column flex-ns items-center db ph3">
    <ul className="list pa0 ma0">
      {[Header, Email, Social, Video, SMS, Contactless].map(
        (SubComp, compIx) => (
          <li
            className={classnames("w-100 dib pt5", {
              "mt4-l": compIx
            })}
            key={compIx}
          >
            <SubComp {...props} />
          </li>
        )
      )}
    </ul>
  </section>
);

export default SellAnywhere;
